<template>
  <div class="floating-controls">
    <div class="control-panel">
      <div class="control-items">
        <div class="control-item" @click="toLink('/new-products/shopping-car')">
          <div class="item-icon">
            <el-badge
              :value="shoppingCartNum > 99 ? '99+' : shoppingCartNum"
              class="cart-badge"
              :hidden="shoppingCartNum == 0"
            >
              <i class="fas fa-shopping-cart"></i>
            </el-badge>
          </div>
          <span class="item-label">购物车</span>
          <div class="item-hover-effect"></div>
        </div>

        <div class="control-item" @click="toLink('/new-products/system-center/order-list')">
          <div class="item-icon">
            <!-- <img :src="myOrder" alt="我的订单" /> -->
            <i class="fas fa-clipboard-list"></i>
          </div>
          <div class="flex-column">
            <span class="item-label">我的</span>
            <span class="item-label">订单</span>
          </div>
          <div class="item-hover-effect"></div>
        </div>

        <!-- <div class="control-item" @click="toLink('/reconciliation')">
          <div class="item-icon">
            <img :src="reconciliationCenter" alt="对账中心" />
          </div>
          <span class="item-label">对账中心</span>
          <div class="item-hover-effect"></div>
        </div> -->

        <div class="control-item" @click="toLink('/new-products/system-center/personal-data')">
          <div class="item-icon">
            <!-- <img :src="manageCenter" alt="管理中心" /> -->
            <i class="fas fa-cog"></i>
          </div>
          <div class="flex-column">
            <span class="item-label">管理</span>
            <span class="item-label">中心</span>
          </div>
          <div class="item-hover-effect"></div>
        </div>
      </div>
    </div>

    <!-- <div class="back-to-top" @click="backTop">
      <div class="top-icon">
        <img :src="goTop" alt="返回顶部" />
      </div>
    </div> -->
  </div>
</template>

<script>
import goTop from "@/assets/img/newProducts/goTop.png";
import manageCenter from "@/assets/img/newProducts/manageCenter.png";
import myOrder from "@/assets/img/newProducts/myOrder.png";
import reconciliationCenter from "@/assets/img/newProducts/reconciliationCenter.png";
import shoppingCar from "@/assets/img/newProducts/shoppingCar.svg";
import tool from "@/utils/tool.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      goTop,
      manageCenter,
      myOrder,
      reconciliationCenter,
      shoppingCar
    };
  },
  computed: {
    ...mapState("user", {
      shoppingCartNum: state => {
        return state.shoppingCartNum;
      }
    }),
    noLoginLook() {
      return this.$store.getters["companyInfo/noLoginLook"];
    }
  },
  methods: {
    backTop() {
      const target = document.getElementById("newProductsPage");
      tool.smoothScrollToTop(800, target);
    },
    toLink(url) {
      if (this.noLoginLook) {
        this.$router.push({ path: "/login" });
        return;
      }
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.floating-controls {
  position: fixed;
  right: 0;
  top: 30%;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.control-panel {
  background: #ffffff;
  // border-radius: 16px 0 0 16px;
  width: 50px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  }
}

.control-items {
  display: flex;
  flex-direction: column;

  .control-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;

    &:hover {
      background: var(--color-primary);

      .item-label {
        color: #fff;
        transform: translateY(-1px);
      }

      .item-icon img {
        transform: scale(1.1);
      }

      .item-hover-effect {
        opacity: 1;
      }
      i {
        color: #fff;
      }
    }

    &:not(:last-child)::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 1px;
      background: linear-gradient(
        90deg,
        color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
        color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
      );
    }

    .item-icon {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px;

      img {
        width: 24px;
        height: 24px;
        transition: all 0.3s ease;
      }
      i {
        font-size: 24px;
      }
      .cart-badge {
        ::v-deep .el-badge__content {
          background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
          border: 2px solid #ffffff;
          font-weight: 600;
          font-size: 10px;
          min-width: 18px;
          height: 18px;
          line-height: 14px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
      }
    }

    .item-label {
      font-size: 12px;
      font-weight: 500;
      color: #555;
      transition: all 0.3s ease;
    }

    .item-hover-effect {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
        color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
      );
      opacity: 0;
      transition: opacity 0.3s ease;
    }
  }
}

.back-to-top {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  background: #ffffff;
  border-radius: 16px 0 0 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    background: linear-gradient(
      135deg,
      color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
      color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
    );

    .top-label {
      color: var(--color-primary);
      transform: translateY(-1px);
    }

    .top-icon img {
      transform: translateY(-2px);
    }

    .top-hover-effect {
      opacity: 1;
    }
  }

  .top-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;

    img {
      width: 48px;
      height: 48px;
      transition: all 0.3s ease;
    }
  }

  .top-label {
    font-size: 12px;
    font-weight: 500;
    color: #555;
    transition: all 0.3s ease;
  }

  .top-hover-effect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
      color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .floating-controls {
    top: auto;
    bottom: 20px;
    flex-direction: row;
    right: 50%;
    transform: translateX(50%);
    gap: 8px;
  }

  .control-panel {
    border-radius: 16px;
    order: 2;
  }

  .control-items {
    flex-direction: row;

    .control-item {
      padding: 12px 16px;

      &:not(:last-child)::after {
        top: 50%;
        left: auto;
        right: 0;
        transform: translateY(-50%);
        width: 1px;
        height: 30px;
        background: linear-gradient(
          135deg,
          color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
          color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
        );
      }
    }
  }

  .back-to-top {
    border-radius: 16px;
    order: 1;
    padding: 12px 16px;
  }
}

@media (max-width: 480px) {
  .floating-controls {
    bottom: 10px;
  }

  .control-items .control-item {
    padding: 10px 12px;

    .item-icon img {
      width: 20px;
      height: 20px;
    }

    .item-label {
      font-size: 11px;
    }
  }

  .back-to-top {
    padding: 10px 12px;

    .top-icon img {
      width: 20px;
      height: 20px;
    }

    .top-label {
      font-size: 11px;
    }
  }
}

/* 动画效果 */
// @keyframes float {
//   0% {
//     transform: translateY(0px);
//   }
//   50% {
//     transform: translateY(-5px);
//   }
//   100% {
//     transform: translateY(0px);
//   }
// }

// .floating-controls {
//   animation: float 6s ease-in-out infinite;
// }

.control-item:hover,
.back-to-top:hover {
  animation: none;
}
</style>
